module.exports = __webpack_public_path__ + "img/LogoPPL.dfbabb08.svg";